(() => {
  if (window.gbCatalogInitialized) return;
  window.gbCatalogInitialized = true;
  const selected = new Map();
  const filterCatalog = (catalog, value) => {
    const cards = [...catalog.querySelectorAll('[data-gb-catalog-item]')];
    let visible = 0;
    cards.forEach(card => {
      const matches = value === 'all' || (card.dataset.gbCatalogItem || '').split(' ').includes(value);
      card.hidden = !matches;
      if (matches) visible++;
    });
    catalog.querySelectorAll('[data-gb-catalog-filter]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.gbCatalogFilter === value));
    });
    const status = catalog.querySelector('[data-gb-catalog-status]');
    if (status) status.textContent = `${visible} ${visible === 1 ? 'opción' : 'opciones'}`;
    const empty = catalog.querySelector('[data-gb-catalog-empty]');
    if (empty) empty.hidden = visible > 0;
    selected.set(catalog.id, value);
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-gb-catalog-filter]');
    if (!button) return;
    const catalog = button.closest('[data-gb-catalog]');
    if (catalog) filterCatalog(catalog, button.dataset.gbCatalogFilter);
  });
  document.querySelectorAll('[data-gb-catalog]').forEach(catalog => {
    const controls = catalog.querySelector('[data-gb-catalog-controls]');
    if (controls) {
      controls.hidden = false;
      catalog.classList.add('gb-catalog--enhanced');
    }
    const profiles = { espresso: 'espresso', filtro: 'filter', chocolate: 'chocolate', fruta: 'fruit' };
    const requested = profiles[new URLSearchParams(window.location.search).get('perfil')];
    const initial = requested && catalog.querySelector(`[data-gb-catalog-filter="${requested}"]`) ? requested : 'all';
    filterCatalog(catalog, initial);
    const grid = catalog.querySelector('#ProductGridContainer');
    if (grid) new MutationObserver(mutations => {
      if (mutations.some(mutation => mutation.type === 'childList')) {
        filterCatalog(catalog, selected.get(catalog.id) || 'all');
      }
    }).observe(grid, { childList: true });
  });
})();
